import { menu } from "svelte-editor-layout";
import { Shortcut } from "@ceyper-common";
import { COMMANDS } from "$lib/commands";
import Icon from "$lib/utility/Icon.svelte";
import { derived, readable, type Readable } from "svelte/store";
import ToggleCommand from "./ToggleCommand.svelte";

function commandAction(
    name: keyof (typeof COMMANDS)["commands"],
    display: string | undefined = undefined
) {
    const command = COMMANDS.commands[name];
    return {
        ...menu.action(display ?? command.name, command.invoke, command.enabled),
        right: {
            component: Shortcut,
            props: { command },
        },
    };
}

function toggleCommandAction(
    name: keyof (typeof COMMANDS)["commands"],
    enabled: Readable<boolean>
) {
    return {
        ...commandAction(name),
        left: {
            component: ToggleCommand,
            props: { checked: enabled },
        },
    };
}

const chevron = { right: { component: Icon, props: { id: "chevron-right-16" } } } as const;
export const MENU = menu.createMenuBar([
    menu.group("File", [
        commandAction("file.new"),
        commandAction("file.open"),
        commandAction("file.download"),
        commandAction("file.download-as"),
        menu.separator(),
        commandAction("file.resize"),
        menu.separator(),
        commandAction("general.settings"),
    ]),
    menu.group("Edit", [
        commandAction("general.undo"),
        commandAction("general.redo"),
        menu.separator(),

        menu.group(
            "Layer",
            [
                commandAction("edit.add-layer"),
                commandAction("edit.remove-layer"),
                commandAction("edit.rename-layer"),

                commandAction("edit.duplicate-layer"),
                commandAction("edit.merge-layers"),

                commandAction("edit.move-layer-up"),
                commandAction("edit.move-layer-down"),

                commandAction("edit.toggle-layer-visibility"),
            ],
            undefined,
            chevron
        ),
        menu.group(
            "Modify",
            [
                commandAction("edit.outline"),
                commandAction("edit.offset"),
                commandAction("edit.clear"),
            ],
            undefined,
            chevron
        ),
    ]),
    menu.group("View", [
        commandAction("camera.center"),
        commandAction("camera.zoom-in-center"),
        commandAction("camera.zoom-out-center"),
        menu.separator(),
        // toggleCommandAction(
        //     "edit.toggle-view-tiling",
        //     derived(activeDisplayOptions, (options) => options.tiling)
        // ),
        // toggleCommandAction(
        //     "edit.toggle-layer-focus",
        //     derived(activeDisplayOptions, (options) => options.focus)
        // ),
        menu.separator(),
        menu.group(
            "Panels",
            [
                commandAction("view.palette", "Palette"),
                commandAction("view.color-picker", "Color picker"),
                commandAction("view.layers", "Layers"),
                commandAction("view.files", "Files"),
                commandAction("view.history", "History"),
                commandAction("view.tool-options", "Tool options"),
            ],
            undefined,
            chevron
        ),
    ]),
]);
